// Presence means neither null nor undefined; false, zero and empty strings
// remain valid values. Accept the value once so callers do not repeat getters.
export function isPresent(value) {
  return value !== null && value !== undefined;
}
